@if(alert && alert.alertPresent) {
<div class="alert system-alert">
    <p>{{alert.message}}</p>
    @if(alert.url) {
    <p>Please see <a [href]="alert.url" target="_blank">more information</a>.</p>
    }
</div>
}